import {showNotification} from "@mantine/notifications";
import {
    AiOutlineExclamation,
    AiOutlineInfo,
    AiOutlineLogin
} from "react-icons/ai";
import config from "../../config";


export const notifySuccess = (message = 'Record saved successfully') => {
    showNotification({
                         title: 'Success',
                         icon: <AiOutlineInfo/>,
                         message: message,
                         color: 'teal',
                     })
}

export const notifyError = (e: any | unknown | undefined = 'Error performing the operation') => {

    console.trace(e);

    if (typeof e === 'string') {
        e = {message: e}
    }

    if (typeof e.errors !== 'undefined' && e.errors.length > 0) {
        e.errors.forEach((error: { message: string; }) => {
            showErrorNotification(error.message);
        })
    } else {

        showErrorNotification(e.message);

        const noCurrentUserMessage = 'no current user'
        if (e.message.toLowerCase() === noCurrentUserMessage) {
            showSessionExpiredNotification();
        }


    }

}

export const showSessionExpiredNotification = (message = 'Redirecting to network portal...Please, wait!') => {

    showNotification({
                         title: 'Session Expired',
                         icon: <AiOutlineLogin/>,
                         message: message,
                         color: 'blue',
                     });


    setTimeout(() => {
        window.location.assign(config.platform.portal + '/sign-in?returnTo=' +
                                   config.platform.console);
    }, 3000);

};

export const showErrorNotification = (message: string) => {
    showNotification({
                         title: 'Error',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })
}


// notify access denied
export const notifyAccessDenied = (message = 'Access denied') => {
    showNotification({
                         title: 'Access Denied',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })
}